import {
  ReactElement, useEffect, useMemo, useState,
} from 'react';
import { UnitsInfoContainer } from 'pages/NewOverview/components/Loading/styles';
import { LoadingUnitsInfo } from 'pages/NewOverview/components/Loading/UnitsInfo';
import { ThermalComfortUnitCard } from './Card';
import { useThermalComfortDataContext } from 'pages/NewOverview/contexts/ThermalComfortDataContext';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from 'helpers/userProfile';
import { useFilterContext } from 'pages/NewOverview/contexts/FilterContext';
import { canSeeDetailsButtonByValue } from '../../helpers';

interface UnitsInfoProps {
  hasThermalComfort: boolean;
  loading: boolean;
}

export function UnitsInfo({
  hasThermalComfort,
  loading,
}: Readonly<UnitsInfoProps>): ReactElement {
  const [profile] = useState(getUserProfile());
  const { selectedOptions, clients } = useFilterContext();
  const history = useHistory();
  const {
    loading: loadingThermal, data, refetch, units,
  } = useThermalComfortDataContext();

  const generalLoading = useMemo(() => loading || (loadingThermal && hasThermalComfort), [hasThermalComfort, loading, loadingThermal]);

  const showValues = hasThermalComfort && !loading;

  function onClickDetails(): void {
    history.push('/analise/conforto-termico');
  }

  useEffect(() => {
    if (hasThermalComfort) {
      const clientIds = clients.map(Number);
      refetch(clientIds, selectedOptions);
    }
  }, [
    selectedOptions.group?.units,
    selectedOptions.state,
    selectedOptions.status,
    selectedOptions.cities,
    selectedOptions.units,
  ]);

  if (generalLoading) {
    return (
      <LoadingUnitsInfo />
    );
  }

  return (
    <UnitsInfoContainer data-testId="thermal-confort-units-info">
      <ThermalComfortUnitCard
        variant="comfortable"
        value={showValues ? data?.comfortable : undefined}
        onClickDetails={() => onClickDetails()}
        canSeeDetails={canSeeDetailsButtonByValue(showValues ? data?.comfortable : undefined)}
      />
      <ThermalComfortUnitCard
        variant="regular"
        value={showValues ? data?.regular : undefined}
        onClickDetails={() => onClickDetails()}
        canSeeDetails={canSeeDetailsButtonByValue(showValues ? data?.regular : undefined)}
      />
      <ThermalComfortUnitCard
        variant="bad"
        value={showValues ? data?.bad : undefined}
        onClickDetails={() => onClickDetails()}
        canSeeDetails={canSeeDetailsButtonByValue(showValues ? data?.bad : undefined)}
      />
      <ThermalComfortUnitCard
        variant="inoperative"
        value={showValues ? data?.inoperative : undefined}
        onClickDetails={() => onClickDetails()}
        canSeeDetails={canSeeDetailsButtonByValue(showValues ? data?.inoperative : undefined)}
      />
    </UnitsInfoContainer>
  );
}
